module.exports = __webpack_public_path__ + "img/UAH.cae46de2.svg";